import { html, css, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import '@material/web/divider/divider.js';

export class IxDivider extends LitElement {
  static styles = css`
    :host {
      display: block;
      width: 100%;
    }
  `;

  /**
   * Indents the divider with equal padding on both sides.
   */
  @property({ type: Boolean }) inset = false;

  /**
   * Indents the divider with padding on the leading side.
   */
  @property({ type: Boolean, attribute: 'inset-start' }) insetStart = false;

  /**
   * Indents the divider with padding on the trailing side.
   */
  @property({ type: Boolean, attribute: 'inset-end' }) insetEnd = false;

  render() {
    return html`
      <md-divider
        .inset=${this.inset}
        .insetStart=${this.insetStart}
        .insetEnd=${this.insetEnd}
      ></md-divider>
    `;
  }
}
